module.exports = __webpack_public_path__ + "static/media/big-lucky-vertical-green-bg-gold-white-300x300.cbcd5fb1.png";